var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 124,
    viewBox: "0 0 96 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V124H96V0Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 124
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 0H6C2.68629 0 0 2.68629 0 6V118C0 121.314 2.68629 124 6 124H90C93.3137 124 96 121.314 96 118V6C96 2.68629 93.3137 0 90 0Z",
    fill: "#4E2AB9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V124H96V0Z",
    fill: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 99C32.6716 99 32 99.6716 32 100.5C32 101.328 32.6716 102 33.5 102H37.5C38.3284 102 39 101.328 39 100.5C39 99.6716 38.3284 99 37.5 99H33.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 105C58.6716 105 58 105.672 58 106.5C58 107.328 58.6716 108 59.5 108H62.5C63.3284 108 64 107.328 64 106.5C64 105.672 63.3284 105 62.5 105H59.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93C32.6716 93 32 93.6716 32 94.5C32 95.3284 32.6716 96 33.5 96H45.5C46.3284 96 47 95.3284 47 94.5C47 93.6716 46.3284 93 45.5 93H33.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 93C50.6716 93 50 93.6716 50 94.5C50 95.3284 50.6716 96 51.5 96H62.5C63.3284 96 64 95.3284 64 94.5C64 93.6716 63.3284 93 62.5 93H51.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 105C32.6716 105 32 105.672 32 106.5C32 107.328 32.6716 108 33.5 108H53.5C54.3284 108 55 107.328 55 106.5C55 105.672 54.3284 105 53.5 105H33.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 99C42.6716 99 42 99.6716 42 100.5C42 101.328 42.6716 102 43.5 102H62.5C63.3284 102 64 101.328 64 100.5C64 99.6716 63.3284 99 62.5 99H43.5Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9602 43.3453C55.7867 43.3453 52.4035 39.9686 52.4035 35.8031C52.4035 31.6377 55.7867 28.2609 59.9602 28.2609C64.1337 28.2609 67.5169 31.6377 67.5169 35.8031C67.5169 39.9686 64.1337 43.3453 59.9602 43.3453Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1624 43.3453C32.9889 43.3453 29.6057 39.9686 29.6057 35.8031C29.6057 31.6377 32.9889 28.2609 37.1624 28.2609C41.3359 28.2609 44.7191 31.6377 44.7191 35.8031C44.7191 39.9686 41.3359 43.3453 37.1624 43.3453Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8875 52.7364C23.1003 52.7364 21.6837 54.2749 22.0614 56.0183C24.6923 68.1622 35.5176 77.2609 48.4721 77.2609C61.4266 77.2609 72.2519 68.1622 74.8827 56.0183C75.2604 54.2749 73.8439 52.7364 72.0567 52.7364H24.8875Z",
    fill: "#CFCFCF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbText);
export default __webpack_public_path__ + "static/media/thumb_text.c1e80a473b48e6a3cdf7d39bd2f4f39a.svg";
export { ForwardRef as ReactComponent };